// extracted by mini-css-extract-plugin
export default {"items":"scroll-buttons_items__Vv2+s","link":"scroll-buttons_link__jE99U","active":"scroll-buttons_active__59UaT"};